import { ReactElement } from 'react'
import { Provider } from 'react-redux'
import store from '../../redux/store'
import { ProviderBFSM } from '../../contexts/bfsmContext'
import { I18nextProvider } from 'react-i18next'
import createI18nInstance from '../../i18n.bookingflow'
import { ProviderEndFlowManager } from '../../contexts/endFlowManagerContext'
import { IEndFlowManager } from '../../services/endflowmanager/EndFlowManager'

const CommonContext = ({
    children,
    bfsmEnvProps,
    locizeOptions,
    endFlowManager,
}: {
    children: ReactElement
    bfsmEnvProps?: {
        REACT_APP_API_URL?: string
        REACT_APP_BASEURL?: string
        REACT_APP_REPOSITORY_MODE?: string
    }
    locizeOptions?: {
        projectId: string
        apiKey: string
        version: string
        referenceLng: string
    }
    endFlowManager?: IEndFlowManager
}) => {
    const i18nBookingflowInstance = createI18nInstance(locizeOptions)

    return (
        <I18nextProvider i18n={i18nBookingflowInstance}>
            <ProviderEndFlowManager endFlowManager={endFlowManager}>
                <ProviderBFSM bfsmEnvProps={bfsmEnvProps}>
                    <Provider store={store}>{children}</Provider>
                </ProviderBFSM>
            </ProviderEndFlowManager>
        </I18nextProvider>
    )
}

export default CommonContext
